import { ProductTitle } from './ProductTitle.js';
const ProductTitleEyebrow = ProductTitle.Eyebrow;
const ProductTitleReview = ProductTitle.Review;
const ProductTitleTitle = ProductTitle.Title;
export { ProductTitle, ProductTitleEyebrow, ProductTitleReview, ProductTitleTitle };
//# sourceMappingURL=index.js.map